import AppUtils from '@/utils/AppUtils'
function commentNode(el, vnode) {
  el.style.display = 'none'
}

export default {
  /**
   *
   * @param {import('vue').App} app
   * @param {Object} options
   */
  install: (app, options) => {
    app.directive('debug', {
      /**
       *
       * @param {HTMLElement} el
       * @returns
       */
      beforeMount(el, binding, vnode) {
        // doNtg
        if (binding.value === false) return
        el.setAttribute('v-debug', 'true') // refer main.css
        if (!AppUtils.isDebugMode()) {
          commentNode(el, vnode) // failsafe
          return
        }
        el.setAttribute('title', '`v-debug`| This is a debug element, will be hidden in production mode')
      }
    })

    app.directive('auth', {
      beforeMount(el, binding, vnode) {
        if (!AppUtils.isLoggedIn() && (binding.value === undefined || binding.value === true)) commentNode(el, vnode)
        if (AppUtils.isLoggedIn() && binding.value === false) commentNode(el, vnode)
      }
    })

    app.directive('roles', {
      beforeMount(el, binding, vnode) {
        if (!AppUtils.allowAccess(false, binding.value)) commentNode(el, vnode)
      }
    })

    app.directive('permissions', {
      beforeMount(el, binding, vnode) {
        if (!AppUtils.allowAccess(false, [], binding.value)) commentNode(el, vnode)
      }
    })

    app.directive('mobile-long-press', {
      beforeMount: function (el, binding) {
        if (!window.vue.$vuetify.display.mobile) return

        let pressTimer = null;

        const start = (e) => {
          // Block iOS context menu
          e.preventDefault();

          // Set timeout only if it’s not already set
          if (pressTimer === null) {
            pressTimer = setTimeout(() => {
              binding.value(e); // Call the method passed to directive
            }, 600); // Customize press time here
          }
        };

        const cancel = () => {
          if (pressTimer !== null) {
            clearTimeout(pressTimer);
            pressTimer = null;
          }
        };

        // Add touch and mouse listeners
        el.addEventListener('touchstart', start, { passive: true });
        el.addEventListener('touchend', cancel);
        el.addEventListener('touchmove', cancel);
        el.addEventListener('touchcancel', cancel);
        el.addEventListener('mousedown', start);
        el.addEventListener('mouseup', cancel);
        el.addEventListener('mouseleave', cancel);

        // Optional: prevent context menu on long press (iOS fallback)
        el.addEventListener('contextmenu', e => e.preventDefault());
      },
      unmounted: function (el) {
        // Clean up listeners if needed
      }
    });


  }
}
